const content: { [key: string]: string } = {
  // Pin Level Labels
  // NOTE: New keys use {performanceYear} variable, legacy keys below use {year}
  pinLevelLabel: "PY{performanceYear} Pin Level",
  pinTrackingLevelLabel: "Pin Tracking Level",
  inMarketPinLabel: "PY{performanceYear} In-Market Pin",
  inMarketPinTrackingLabel: "In-Market Pin Tracking",

  // Legacy labels (kept for backward compatibility) - use {year} instead of {performanceYear}
  inMarketCurrentReqDescription: "In-Market Pin Tracking",
  inMarketPreviousReqDescription: "PY{year} In-Market Pin",
  garTrackingDescription: "GAR Tracking",
  garLevelDescription: "PY{year} GAR Level",
} as const;

export default content;
